import { useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { connect, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import MButton from "../components/commons/MButton";
import MPageFooter from "../components/commons/MPageFooter";
import MPageHeader from "../components/commons/MPageHeader";
import { AvatarAction } from "../redux/actions/AvatarAction";
import { AppConstant, AuthConstant, AvatarConstant } from "../redux/reducers";
import { STATUS } from "../constants/avatar";

const QREntry = ({ CheckAvatarId, avatarStatus }) => {
  const { t } = useTranslation();
  const { id, region } = useParams()
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [height, setHeight] = useState(0);
  const ref = useRef();

  useEffect(() => {
    dispatch({ type: AppConstant.SET_SHOW_PASSWORD, show: false });
    dispatch({ type: AppConstant.SET_SHOW_TEAMS_CHECK, show: false });
  }, [dispatch]);

  const openPassword = useCallback(() => {
    dispatch({ type: AvatarConstant.SET_TEMP_PASSWORD, value: "" });
    dispatch({ type: AppConstant.SET_SHOW_PASSWORD, show: true });
  }, [dispatch]);

  useEffect(() => {
    dispatch({ type: AuthConstant.SET_TRIGGER_AUTH, item: { _id: id, region: region } });
  }, [dispatch, id, region])

  const checkAvatar = useCallback(async () => {
    if (id && region) {
      setLoading(true);
      const item = await CheckAvatarId(id, region);
      if (!item) {
        dispatch({ type: AvatarConstant.SET_AVATAR, item: { status: STATUS.WRONG } })
        // navigate("/error/wrong-access");
        return;
      }
      setLoading(false);
    }
  }, [id, region, CheckAvatarId]);

  useEffect(() => {
    checkAvatar();
  }, [checkAvatar]);

  useEffect(() => {
    setHeight(ref?.current?.clientHeight || 0);
    const handlerResize = () => {
      setHeight(ref?.current?.clientHeight || 0);
    };
    window?.addEventListener("resize", handlerResize);
    return () => {
      window?.removeEventListener("resize", handlerResize);
    };
  }, []);

  return <div className="w-100 h-100 d-flex flex-column">
    <MPageHeader />
    <div
      className="flex-fill d-flex flex-column px-4"
      style={{
        backgroundImage: `url("/imgs/welcome.png")`,
        backgroundPosition: "center center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "auto, auto"
      }}
    />
    <div style={{
        width: "100%",
        minHeight: height,
        zIndex: 1,
      }} />
    <div style={{ position: "fixed", left: 0, bottom: 0, right: 0, zIndex: 2 }}>
      {/* <MPageFooter noneFooterGap={true} position="absolute"> */}
      <div
        className="text-center text-primary fs-7 pb-2 px-4"
        style={{
          paddingTop: 40,
          background: "linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, #FFF 50.67%)",
        }}
      >
        {t("To protect your privacy, you'll need to agree to use it and set a password.")}
      </div>
      <div ref={ref} className="bg-white px-4 pb-4">
        <MButton
          css="w-100 text-white py-2"
          circle={true}
          height={56}
          disabled={loading}
          onClick={openPassword}
        >
          {t("Set Password")}
        </MButton>
      </div>
      {/* </MPageFooter> */}
    </div>
  </div>
};


const mapState = (state) => {
  const avatarStatus = state.AvatarReducer.status;
  return { avatarStatus };
};

const mapDispatch = dispatch => ({
  CheckAvatarId: (id, region) => dispatch(AvatarAction.CheckAvatarId(id, region)),
});

export default connect(mapState, mapDispatch)(QREntry);
